import { useCallback, useEffect, useState } from "react";
import { Search } from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import {
  Box,
  Button,
  Container,
  Card,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";

// @material-ui/lab components
import { Skeleton } from "@material-ui/lab";
// @material-ui/icons components
import {
  Create,
  Delete,
  Refresh as RefreshIcon,
  Add as AddIcon,
} from "@material-ui/icons";
// core components
import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import FormMenuDialog from "components/Dialogs/FormMenuDialog";
import ToggleCell from "components/Cells/ToggleCell";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import componentStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";
import Api from "lib/api/httpRequestHelper";
import MaskAndValid from "utils/maskAndValid";
import { IsMobile } from "utils/is-mobile";

const getTableColumns = (
  setSelectedMenu,
  toggleFormDialog,
  toggleAtivo,
  searching
) => [
  {
    dataField: "IdMenu",
    text: "IdMenu",
    sort: true,
    formatter: (menu) => (searching ? <Skeleton variant="text" /> : menu),
  },
  {
    dataField: "IdMenuPai",
    text: "IdMenuPai",
    sort: true,
    formatter: (menu) =>
      searching ? <Skeleton variant="text" /> : menu || "-",
  },
  {
    dataField: "Nome",
    text: "Nome",
    sort: true,
    formatter: (menu) => (searching ? <Skeleton variant="text" /> : menu),
  },
  {
    dataField: "NomeInterno",
    text: "Nome Interno",
    sort: true,
    formatter: (menu) => (searching ? <Skeleton variant="text" /> : menu),
  },
  {
    dataField: "Sistema",
    text: "Sistema",
    sort: true,
    formatter: (menu) => (searching ? <Skeleton variant="text" /> : menu),
  },
  {
    dataField: "DataAlteracao",
    text: "Data de Alteração",
    formatter: (menu) =>
      searching ? (
        <Skeleton variant="text" />
      ) : (
        MaskAndValid.formattDateBR(menu)
      ),
    sort: true,
  },
  {
    dataField: "Ativo",
    text: "Ativo",
    headerStyle: { width: 90 },
    formatter: (cell, row) => {
      return (
        <ToggleCell
          initialValue={row.Ativo}
          handleChange={async (params) => {
            row.Ativo = params.Ativo;

            await toggleAtivo({ ...row, ...params });
          }}
          initialLoading={searching}
          field="Ativo"
        />
      );
    },
    sort: true,
  },
  {
    dataField: "ViewMenu",
    text: "ViewMenu",
    formatter: (menu) =>
      searching ? <Skeleton variant="text" /> : MaskAndValid.formatYesNo(menu),
    sort: true,
  },
  {
    dataField: "SessaoMenu",
    text: "SessaoMenu",
    formatter: (menu) =>
      searching ? <Skeleton variant="text" /> : MaskAndValid.formatYesNo(menu),
    sort: true,
  },
  {
    dataField: "editar",
    text: "",
    isDummyField: true,
    headerStyle: { width: 45 },
    formatter: (cell, row) => {
      return searching ? null : (
        <Tooltip title="Editar Menu">
          <IconButton
            aria-label="edit"
            onClick={() => {
              setSelectedMenu(row);
              toggleFormDialog("edit");
            }}
          >
            <Box
              component={Create}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      );
    },
  },
  {
    dataField: "deletar",
    text: "",
    isDummyField: true,
    headerStyle: { width: 45 },
    formatter: (cell, row) =>
      searching ? null : (
        <Tooltip title="Deletar Menu">
          <IconButton
            aria-label="delete"
            onClick={() => {
              setSelectedMenu(row);
              toggleFormDialog("delete");
            }}
          >
            <Box
              component={Delete}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      ),
  },
];

const loadingItems = [
  { IdMenu: "0" },
  { IdMenu: "1" },
  { IdMenu: "2" },
  { IdMenu: "3" },
  { IdMenu: "4" },
  { IdMenu: "5" },
  { IdMenu: "6" },
  { IdMenu: "7" },
  { IdMenu: "8" },
  { IdMenu: "9" },
];

const { SearchBar } = Search;

const useStyles = makeStyles(componentStyles);

function Menus() {
  const classes = useStyles();
  const snackbar = useSnackbar();
  const [menus, setMenus] = useState(loadingItems);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [searching, setSearching] = useState(true);
  const isMobile = IsMobile();

  const toggleFormDialog = useCallback((formType) => {
    if (formType) {
      setOpenFormDialog(formType);
    }
  }, []);

  const toggleAtivo = (updatedMenu) => {
    return Api.postParams(
      "update-menu",
      "adminportal",
      "?nome=" +
        updatedMenu.Nome +
        "&nomeInterno=" +
        updatedMenu.NomeInterno +
        "&sistema=" +
        updatedMenu.Sistema +
        "&idMenuPai=" +
        updatedMenu.IdMenuPai +
        "&viewMenu=" +
        updatedMenu.ViewMenu +
        "&sessaoMenu=" +
        updatedMenu.SessaoMenu +
        "&ativo=" +
        updatedMenu.Ativo.toString() +
        "&idMenu=" +
        updatedMenu.IdMenu.toString(),
      true
    )
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(
            `Menu ${updatedMenu.IdMenu.toString()} foi ${
              updatedMenu.Ativo ? "ativado" : "desativado"
            } com sucesso!`,
            {
              severity: "success",
            }
          );
        } else {
          snackbar.showMessage(
            `Ocorreu um erro ao ${
              updatedMenu.Ativo ? "ativar" : "desativar"
            } Menu ${updatedMenu.IdMenu.toString()}. Verifique os parâmetros informados.`,
            {
              severity: "error",
            }
          );
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      });
  };

  const updateList = async (openFormDialog, updatedMenu) => {
    if (openFormDialog === "delete") {
      const filteredMenu = menus.filter(
        (menu) => menu.IdMenu !== updatedMenu.IdMenu
      );

      setMenus(filteredMenu);
    } else {
      const newMenuList = menus?.map((menu) => {
        if (menu.IdMenu === updatedMenu.IdMenu) return updatedMenu;
        else return menu;
      });

      setMenus(newMenuList);
    }
  };

  const fetchList = async () => {
    await Api.get("list-menu", "adminportal", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          setMenus(Result);
          setSearching(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      });
  };

  const handleRefresh = async () => {
    setSearching(true);

    return fetchList();
  };

  useEffect(() => {
    fetchList();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderClientes section="Menus" subsection="Administração" />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <ToolkitTable
                keyField="IdMenu"
                dataTable={searching ? loadingItems : menus}
                columnModel={getTableColumns(
                  setSelectedMenu,
                  toggleFormDialog,
                  toggleAtivo,
                  searching
                )}
                search
                allowEmpty
                CustomHeader={({ searchProps }) => (
                  <Grid
                    container
                    className="pl-4"
                    style={{ padding: isMobile ? "0 24px 10px" : "0 24px" }}
                  >
                    <Grid item xs={isMobile ? 12 : 4}>
                      <Box
                        component={Typography}
                        variant="h2"
                        marginBottom="0!important"
                      >
                        <Box component="span">Lista de Menus</Box>
                        <IconButtonLoader
                          size="medium"
                          extraStyle={{
                            width: 24,
                            height: 24,
                            marginLeft: "0.3rem",
                          }}
                          title="Recarregar lista"
                          onClick={handleRefresh}
                          icon={<RefreshIcon color="primary" />}
                          aria-label="refresh"
                          color="primary"
                          disabled={searching}
                        />
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xs={isMobile ? 12 : 8}
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        justifyContent: isMobile ? "flex-start" : "flex-end",
                        flexDirection: isMobile ? "column" : "row",
                      }}
                    >
                      <SearchBar
                        className="form-control"
                        placeholder="Pesquisar Menu"
                        {...searchProps}
                        disabled={searching}
                      />
                      <Box
                        justifyContent="flex-end"
                        display="flex"
                        flexWrap="wrap"
                        style={{ marginLeft: isMobile ? 0 : 15 }}
                      >
                        <Button
                          variant="contained"
                          classes={{
                            root: classes.buttonRootWhite,
                          }}
                          onClick={() => toggleFormDialog("create")}
                          disabled={searching}
                        >
                          <Box
                            component={AddIcon}
                            position="relative"
                            top="-2px"
                          />{" "}
                          Criar
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                )}
                pagination={{
                  options: [25, 50, 100],
                  defaultOption: 25,
                }}
              />
            </Card>
          </Grid>
        </Grid>
      </Container>
      {Boolean(openFormDialog) && (
        <FormMenuDialog
          open
          formType={openFormDialog}
          onClose={(menu) => {
            setSelectedMenu(null);
            if (menu?.IdMenu > 0) {
              if (openFormDialog === "create") {
                const newMenuList = [...menus, { ...menu }];

                setMenus(newMenuList);
              } else {
                updateList(openFormDialog, menu);
              }
            }
            setOpenFormDialog(null);
          }}
          selectedMenu={selectedMenu}
        />
      )}
    </>
  );
}

Menus.propTypes = {};

export default Menus;
